export enum LoginDataCySelector {
    USERNAME_INPUT = 'username-input',
    PASSWORD_INPUT = 'password-input',
    LOGIN_SUBMIT_BUTTON = 'login-submit-button',
    FORGOT_PASSWORD_LINK = 'forgot-password-link'
}
